import { ReactNode } from "react";
import { Box } from "@chakra-ui/react";

// Lightweight local type to represent Chakra-style responsive values.
type ChakraResponsiveSize =
  | string
  | number
  | Array<string | number | null>
  | Record<string, string | number | null>;

interface SkewedBackgroundProps {
  children?: ReactNode;
  direction?: "down" | "up"; // "down" for -skew-y, "up" for +skew-y
  /** Chakra responsive min height prop */
  minH?: ChakraResponsiveSize;
  /** Theme token for gradient start (e.g. 'moveon.publicGradientFrom') */
  gradientFrom?: string;
  /** Theme token for gradient end */
  gradientTo?: string;
}

export default function SkewedBackground({
  children,
  direction = "down",
  minH,
  gradientFrom = "moveon.publicGradientFrom",
  gradientTo = "moveon.public.surface.base",
}: SkewedBackgroundProps) {
  // Choose skew angle based on direction
  const skewAngle = direction === "down" ? "-3deg" : "3deg";

  // Offset decorative background so the skew starts below the section top edge.
  const topOffset = "4rem";

  return (
    <Box position="relative" minH={minH}>
      {/* Decorative skewed background */}
      <Box
        position="absolute"
        left={0}
        right={0}
        top={topOffset}
        bottom={0}
        transform={`skewY(${skewAngle})`}
        transformOrigin="0 0"
        bgGradient="to-t"
        gradientFrom={gradientFrom}
        gradientTo={gradientTo}
        zIndex={0}
        aria-hidden="true"
        pointerEvents="none"
      />

      <Box position="relative" zIndex={10}>
        {children}
      </Box>
    </Box>
  );
}
